import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { GUIDE_PDF } from '../components/Help';

const TILES = [
  { to: '/lots/new', icon: '➕', title: 'Create lot', text: 'Scan a label, pick the product, photos, location' },
  { to: '/lots/new?tour=1', icon: '🎓', title: 'How to list', text: 'Replay the Create lot tour' },
  { to: '/find', icon: '🔍', title: 'Find lot', text: 'Scan a lot label to see it and where it is' },
  { to: '/move', icon: '📍', title: 'Move lots / bins', text: 'Scan a location, then scan lots or bins into it' },
  { to: '/bins', icon: '🧺', title: 'Bins', text: 'Pack lots into bins for the store, print bin labels and packing lists' },
  { to: '/lots', icon: '📋', title: 'All lots', text: 'Search, filter and review lots' },
  { to: '/products', icon: '📦', title: 'Products', text: 'Search, add and edit products' },
  { to: '/imports/new', icon: '⬆️', title: 'Import products', text: 'Add new products from the master list (Excel) or a CSV' },
  { to: '/labels', icon: '🏷️', title: 'Lot labels', text: 'Issue and print 1.5″ × 1″ lot labels' },
];
const ADMIN_TILES = [{ to: '/web-data', icon: '🌐', title: 'Costco data', text: 'Titles, descriptions and photos from Costco websites' }];

export function HomePage() {
  const { user } = useAuth();
  return (
    <div>
      <h1>Hello, {user?.displayName}</h1>
      <div className="tiles">
        {[...TILES, ...(user?.role === 'admin' ? ADMIN_TILES : [])].map((t) => (
          <Link key={t.to} to={t.to} className="tile">
            <span className="tile-icon">{t.icon}</span>
            <span className="tile-title">{t.title}</span>
            <span className="tile-text">{t.text}</span>
          </Link>
        ))}
      </div>
      <p>
        <a href={GUIDE_PDF} target="_blank" rel="noreferrer">
          📄 Lister work instructions (printable PDF)
        </a>
      </p>
      <p className="muted small">Auction batches &amp; exports (stage 2) and sales import &amp; pickup (stage 3) are not built yet.</p>
    </div>
  );
}
